<template>
  <div class="row">
    <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="row justify-content-end filter-section">
            <div class="filters-wrapper">
                <span class="filter-header">Filters:</span>
                <div v-for="data, index in filters">
                    <SelectComponent 
                        :placeholder="data.default" 
                        :options="data.options" 
                        :value="data.selected" 
                        @onSelect="(option) => $emit('onSelect', option, index)"
                    />
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import SelectComponent from './ui/SelectComponent.vue';

    export default {
        components: {
            SelectComponent
        },
        props: ['filters'],
        methods: {

        }
    }
</script>
